fx.ns("desktop.print", class PrintEditor extends fx.Component {
    
	constructor(data)
	{
		super(data);
	}

	contextMenu(e)
	{
        return [];
	}

	create()
	{
		super.create();

		this.mediaTabs = new desktop.print.MediaTabs( this.data );
        this.addChild(this.mediaTabs, {top:0,left:0,width:340,height:"100%"});

		this.board = new desktop.print.PrintBoard(this.data, desktop.print.ComponentFactory);
		this.addChild(this.board, {top:0,left:340,width:"100%",height:"100%"});
		
		this.topBar = new desktop.common.actionbar.TopBar( this.data.creation);
		this.addChild(this.topBar,  {top:20,right:25,width:100});

		this.actionBar = new desktop.common.actionbar.ActionBar( this.data);
		this.addChild(this.actionBar,  {top:"center",right:25,width:70});

		this.topNotifications = new desktop.print.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, {top : 10, right : 25});

		this.dragger = new desktop.common.behaviour.ComponentDragger( this.data, this );
		
        this._optionSelectContainer = new fx.components.Box();
        this._optionSelectContainer.effect = "scroll";

        this.addChild( this._optionSelectContainer );		
	}

	onDisplayUpdated()
    {
		if (this._optionSelectContainer)
       		this._optionSelectContainer.viewport({ width : this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height : 50, top : 10, left : this.board.left()});
    }

	onReady()
	{
		super.onReady();

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		this.on("photo-extracted", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

		if (this.mediaTabs)
			this.mediaTabs.currentArea = this.board.currentArea;

        this.on("scrolled", this._onScroll, this.board);
		
		this.on("order", this._onOrder, this.topBar);
        this.on("exit", this._onExit, this.topBar);

		this.listenUpdates(this.data.creation, true);

		this.data.creation.deleted = 0;
    }

	show(callback)
	{
		super.show(callback);
		fx.set("mode", "edition");
	}

    _onScroll()
	{
		if (this._optionSelectContainer)
			this._optionSelectContainer.toggle(this.board.scrollTop <= 30 && this.data.zoom.value == 100);
	}

    _onOrder()
    {
        this.data.event("order");
    }

    _onExit()
    {
        this.data.event("exit-editor");
    }
	
	enable()
	{
		super.enable();
		this.board.enable();
	}

	disable()
	{
		super.disable();
		this.board.disable();
	}

	onCurrentAreaChanged(e)
	{
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;
	}

	onCurrentElementChanged(e)
	{
		// nothing to do
	}

	onDataEvent(e)
	{
		switch(e.type)
		{
			case "share-upload-started":
				this.popup(new shared.popups.SharedPhotosPopup(this.data));
				break;

			case "switch-photoPanel":
				this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;

			case "share-upload-validated":
				this.mediaTabs.selectFilter(0);
				break;

			case "currentAreaChanged" :
				this.onCurrentAreaChanged(e);
				break;

			case "custom-layout-creating" :
            	this.loading(true, fx.text("Sauvegarde de votre mise en page ..."));
				break;

			case "custom-layout-created" :
				this.mediaTabs.tabs.selectTab(this.mediaTabs.layoutPanel);
				this.loading(false);
				break;

			case "custom-layout-error" :
				this.loading(false);
				break;
		}
	}

});